module.exports = __webpack_public_path__ + "media/shuffle2.2cd1dc97.wav";